import React from "react";
import { IconButton } from "@mui/material";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "components/ui/dropdown-menu_v2";
import {
  EllipsisVertical,
  CircleCheck,
  CircleX,
  Pencil,
  Archive,
} from "lucide-react";

const HistoryActionsMenu = ({
  msg,
  openMenuId,
  setOpenMenuId,
  setSelectedHistoryItem,
  setEditingHistoryId,
  setEditedTitle,
  updateHistoryData,
  localization,
  isOutsideDateRange,
  isInTheFutureOrActive,
  now,
}) => {
  return (
    <DropdownMenu
      open={openMenuId === msg.id}
      onOpenChange={(open) => {
        setOpenMenuId(open ? msg.id : null);
        if (open) setSelectedHistoryItem(msg);
      }}
    >
      <DropdownMenuTrigger asChild>
        <IconButton
          size="small"
          sx={{ marginLeft: "auto" }}
          onClick={(e) => e.stopPropagation()}
        >
          <EllipsisVertical className="w-5 h-5" />
        </IconButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent side="right" align="start" className="w-48">
        {msg?.privacy === "public" &&
          !msg?.archived &&
          isInTheFutureOrActive(msg) && (
            <DropdownMenuItem
              onClick={() => {
                updateHistoryData(
                  isOutsideDateRange(msg, new Date())
                    ? "activate"
                    : "deactivate",
                  msg,
                );
                setOpenMenuId(null);
              }}
            >
              {isOutsideDateRange(msg, now) ? (
                <CircleCheck className="w-4 h-4 mr-2 text-green-500" />
              ) : (
                <CircleX className="w-4 h-4 mr-2 text-red-500" />
              )}
              {isOutsideDateRange(msg, now)
                ? localization.start_history || "Start History"
                : localization.stop_history || "Stop History"}
            </DropdownMenuItem>
          )}

        {!msg?.archived && (
          <DropdownMenuItem
            onClick={(e) => {
              e.stopPropagation();
              setEditingHistoryId(msg.id);
              setEditedTitle(msg.title);
              setOpenMenuId(null);
            }}
          >
            <Pencil
              className="w-4 h-4 mr-2"
              style={{
                color: "var(--primary-action)",
              }}
            />
            {localization.edit || "Edit"}
          </DropdownMenuItem>
        )}

        <DropdownMenuItem
          onClick={(e) => {
            e.stopPropagation();
            updateHistoryData(msg?.archived ? "unarchive" : "archive", msg);
            setOpenMenuId(null);
          }}
        >
          <Archive
            className="w-4 h-4 mr-2"
            style={{
              color: "var(--warning-toast)",
            }}
          />
          {msg?.archived
            ? localization.unarchive || "Unarchive"
            : localization.archive || "Archive"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default HistoryActionsMenu;
